/* eslint-disable @typescript-eslint/no-explicit-any */
import { ITooltipParams, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { ColumnDefinition, setPrice } from '@res/ngg-core';

export const storageBaseSchema: ColumnDefinition[] = [
  {
    id: 'invoiceID',
    name: 'invoiceID',
  },
  {
    id: 'invoiceFile',
    name: 'invoiceFile',
    type: 'upload',
  },
  {
    id: 'invoiceDate',
    name: 'invoiceDate',
    type: 'datepicker',
    colDef: { editable: true, cellEditor: 'agDateCellEditor', cellDataType: 'date' },
  },
];

export const storageBulkNoCompatSchema: ColumnDefinition[] = [
  {
    id: 'modelName',
    name: 'modelName',
    type: 'convertibleDropdown',
    canBulk: true,
    isPlain: true,
    dropdownValues: {
      isNotRef: true,
      dropdownCollectionField: 'storage/modelName',
      filter: { op: '==', fieldPath: 'storage/type' },
    },
  },
  { id: 'serialNumber', name: 'serialNumber', type: 'number', canBulk: true },
  {
    id: 'importPrice',
    name: 'importPrice',
    type: 'currency',
    canBulk: true,
    dropdownValues: [
      { key: 'HUF', value: 'HUF' },
      { key: 'USD', value: 'USD' },
      { key: 'EUR', value: 'EUR' },
    ],
  },
  {
    id: 'sellPrice',
    name: 'sellPrice',
    type: 'currency',
    canBulk: true,
    dropdownValues: [
      { key: 'HUF', value: 'HUF' },
      { key: 'USD', value: 'USD' },
      { key: 'EUR', value: 'EUR' },
    ],
  },
];

export const storageBulkCompatSchema: ColumnDefinition[] = [
  ...storageBulkNoCompatSchema,
  {
    id: 'compatibleMachine',
    name: 'compatibleMachine',
    type: 'multiSelectDropdown',
    canBulk: true,
    dropdownValues: { dropdownCollectionField: 'storage/modelName', addEmpty: true },
  },
];

export const storageKioskViewSchema: ColumnDefinition[] = [
  {
    id: 'modelName',
    name: 'modelName',
    type: 'convertibleDropdown',
    canBulk: true,
    isPlain: true,
    dropdownValues: {
      dropdownCollectionField: 'storage/modelName',
      filter: { op: '==', fieldPath: 'storage/type' },
    },
  },
  { id: 'serialNumber', name: 'serialNumber', type: 'number', canBulk: true },
  {
    id: 'invoiceDate',
    name: 'invoiceDate',
    type: 'datepicker',
  },
  {
    id: 'importPrice',
    name: 'importPrice',
    type: 'currency',
    canBulk: true,
    dropdownValues: [
      { key: 'HUF', value: 'HUF' },
      { key: 'USD', value: 'USD' },
      { key: 'EUR', value: 'EUR' },
    ],
  },
  {
    id: 'sellPrice',
    name: 'sellPrice',
    type: 'currency',
    canBulk: true,
    dropdownValues: [
      { key: 'HUF', value: 'HUF' },
      { key: 'USD', value: 'USD' },
      { key: 'EUR', value: 'EUR' },
    ],
  },
  {
    id: 'invoiceID',
    name: 'invoiceID',
  },
  {
    id: 'invoiceFile',
    name: 'invoiceFile',
    type: 'upload',
  },
];

export const storagePartsViewSchema: ColumnDefinition[] = [
  ...storageKioskViewSchema,
  {
    id: 'compatibleMachine',
    name: 'compatibleMachine',
    type: 'dropdown',
    canBulk: true,
    dropdownValues: { dropdownCollectionField: 'machines/type', addEmpty: true },
  },
];

export const storageTabletViewSchema: ColumnDefinition[] = [...storageKioskViewSchema];
export const storageCashMachineViewSchema: ColumnDefinition[] = [...storageKioskViewSchema];
export const storageAllViewSchema: ColumnDefinition[] = [
  {
    id: 'type',
    name: 'type',
    colDef: {
      // cellRenderer: 'agGroupCellRenderer',
      // rowGroup: true,
      // hide: true,
    },
  },
  {
    id: 'cId',
    name: 'cId',
  },
  {
    id: 'modelName',
    name: 'modelName',
    type: 'convertibleDropdown',
    canBulk: true,
    isPlain: true,
    dropdownValues: {
      dropdownCollectionField: 'storage/modelName',
      filter: { op: '==', fieldPath: 'storage/type' },
    },
  },
  { id: 'serialNumber', name: 'serialNumber', type: 'number', canBulk: true },
  {
    id: 'invoiceDate',
    name: 'invoiceDate',
    type: 'datepicker',
  },
  {
    id: 'importPrice',
    name: 'importPrice',
    type: 'currency',
    canBulk: true,
    colDef: {
      valueFormatter: (params: ValueFormatterParams) => {
        return setPrice(params.data.importPrice.amount, params.data.importPrice.type);
      },
    },
    dropdownValues: [
      { key: 'HUF', value: 'HUF' },
      { key: 'USD', value: 'USD' },
      { key: 'EUR', value: 'EUR' },
    ],
  },
  {
    id: 'sellPrice',
    name: 'sellPrice',
    type: 'currency',
    canBulk: true,

    colDef: {
      valueFormatter: (params: ValueFormatterParams) => {
        return setPrice(params.data.sellPrice.amount, params.data.sellPrice.type);
      },
    },
    dropdownValues: [
      { key: 'HUF', value: 'HUF' },
      { key: 'USD', value: 'USD' },
      { key: 'EUR', value: 'EUR' },
    ],
  },
  {
    id: 'invoiceID',
    name: 'invoiceID',
  },
  {
    id: 'invoiceFile',
    name: 'invoiceFile',
    type: 'upload',
  },
  {
    id: 'compatibleMachine',
    name: 'compatibleMachine',
    type: 'multiSelectDropdown',
    canBulk: true,
    dropdownValues: { dropdownCollectionField: 'machines/type', addEmpty: true },
    colDef: {
      valueGetter: (params: ValueGetterParams) => {
        if (Array.isArray(params.data.compatibleMachine) && params.data.compatibleMachine.length) {
          return params?.data.compatibleMachine.map((y: any) => y.key);
        } else {
          return ((params.context ?? params.data.context).storageStore as any)
            .storages()
            .filter(
              (x: any) =>
                params.data.compatibleMachine !== undefined &&
                ((typeof params?.data.compatibleMachine === 'string' &&
                  x.ref.id === params?.data.compatibleMachine?.split('/')?.[1]) ||
                  x.ref.id === params?.data?.compatibleMachine),
            )
            .map((x: any) => x.modelName);
        }
      },

      valueFormatter: (params: ValueFormatterParams) =>
        params.value.length > 1 ? `${params.value[0]}, +${params.value.length - 1}` : params.value.join(', '),

      tooltipValueGetter: (p: ITooltipParams) => p.value.join(', '),
    },
  },
];
